export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  OAUTH_CALLBACK: "/oauth/callback",
  OAUTH_ERROR: "/oauth/error",
  NOT_FOUND: "*"
} as const
